// Shared color constants for UI components
export const ORANGE_ACTION = '#FF7A45';
export const ACTION_ICON_COLOR = '#FFFFFF';

// Expose brand palette shortcut if needed elsewhere
export const BRAND_COLORS = ['#FF7A45', '#FF6B35', '#FF9C66'];
